import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../configuration/configuration.service';
import { FieldConfig } from '../../../../../shared/models/field-config';

@Injectable({
  providedIn: 'root'
})
export class PredefinedValuesService {

  public static PREDEFINED = 'predefined';
  public values: PredefinedValues;

  constructor(private configuration: ConfigurationService) {
    this.values = this.configuration.uiConfig.predefinedValues;
  }

  public addPredefinedValue(field: FieldConfig, pv: PredefinedValues, formConfigKey: string, fieldKey: string) {
    const predefinedValue = this.getPredefinedValue(
      pv,
      formConfigKey,
      fieldKey
    );

    if (predefinedValue) {
      field[PredefinedValuesService.PREDEFINED] = predefinedValue;
    }
  }

  private getPredefinedValue(pv: PredefinedValues, formConfigKey: string, fieldKey: string) {
    try {
      return pv[formConfigKey][fieldKey]
    } catch (e) {
      return void 0;
    }
  }
}

export interface PredefinedValue {
  isPredefined: boolean;
  additionalInfo: string;
}

export interface PredefinedValues {
  CONTACT_SECTION?: {
    [key: string]: PredefinedValue
  }
  CO_OWNER_DATA_SECTION?: {
    [key: string]: PredefinedValue
  }
  OWNER_DATA_SECTION?: {
    [key: string]: PredefinedValue
  }
  VEHICLE_DATA_SECTION?: {
    [key: string]: PredefinedValue
  }
  VEHICLE_MODEL_SECTION?: {
    [key: string]: PredefinedValue
  }
  ADDITIONAL_INFORMATION_SECTION?: {
    [key: string]: PredefinedValue
  }
}
